import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import {
  DialogHeader,
  DialogFooter,
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@/new/components/shadcn/dialog';

export function VerifyDisclaimer() {
  return (
    <div className="py-px text-center text-xs text-gray-400">
      Always review sources to verify answers.{' '}
      <Dialog>
        <DialogTrigger className="rounded-sm text-gray-500 ring-teal-500 ring-offset-2 ring-offset-transparent transition-colors duration-150 hover:text-gray-600 focus:outline-none focus-visible:ring-1 focus-visible:ring-offset-gray-50">
          Read more
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              <Icon className="lucide--shield-alert" /> Always verify Kim answers
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <p>
              Kim has undergone extensive testing to increase the accuracy of its answers. However, as with all
              generative AI systems, in complex scenarios it can return an inaccurate answer.
            </p>
            <p>
              Crucially, you should check the source fact and document in the citation to verify the answer's
              completeness or accuracy.
            </p>
          </div>

          <DialogFooter>
            <DialogClose asChild>
              <Button>Dismiss</Button>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      .
    </div>
  );
}
